export default "__VITE_ASSET__C00I29xJ__"